import {
    SET_OFFER_CAMPAIGNS,
    CLEAR_OFFER_CAMPAIGNS,
    GET_OFFER_CAMPAIGNS_SUCCESS,
    GET_OFFER_CAMPAIGNS_FAILED,
} from '../../actions/type';

const initialState = { data: null, status: 'idle' };

export default function offerReducer(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case SET_OFFER_CAMPAIGNS:
            return {
                ...state,
                data,
            }
        case CLEAR_OFFER_CAMPAIGNS:
            return {
                ...state,
                data: null,
            }
        case GET_OFFER_CAMPAIGNS_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_OFFER_CAMPAIGNS_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}